import{KitProvider}from'@baseext/kit';import'@baseext/shared/src/web/index.css';export default KitProvider;